/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {ActivatedRouteSnapshot} from '@angular/router';
import {MedicalEducation} from '../../../../domain/model/education/medical/medical-education.model';
import {MedicalEducationService} from '../../../../domain/model/education/medical/medical-education.service';
import {CompletedInUSAProjection} from '../../../../domain/model/education/medical/medical-education.projections';
import {
    IdBasedNavigationScreensManager,
    ScreensManagerDeps
} from '../../../../components/sections/service/screen-manager.class';
import {Screen} from '../../../../components/sections/service/screen.class';
import {Step} from '../../../../components/sections/service/step.class';

interface Parameters {
    index: string;
}

export const PremedicalEducationScreens = {
    QUESTION: 'question',
    ECFMG: 'ecfmg',
    PREMEDICAL: 'premedical'
};

@Injectable()
export class PremedicalEducationScreensManager extends IdBasedNavigationScreensManager {

    private _currentScreen$ = new ReplaySubject<Screen>(1);
    screenChange$: Observable<boolean> = this._currentScreen$.map(() => true).publishReplay(1).refCount();

    medicalEducationCompletedInUsa$ = new ReplaySubject<MedicalEducation|undefined>(1);
    completedInUSA$: Observable<boolean>;
    completedInUSA?: boolean;

    set medicalEducationCompletedInUsa(value: MedicalEducation|undefined) {
        this.medicalEducationCompletedInUsa$.next(value);
    }

    constructor(smgm: ScreensManagerDeps, private readonly _educationService: MedicalEducationService) {
        super(smgm);

        this.completedInUSA$ = this.medicalEducationCompletedInUsa$
            .map(model => model ? model.completedInUSA : undefined)
            .publishReplay(1).refCount();

        this.completedInUSA$.subscribe(value => {
            return this.completedInUSA = value;
        });

        this._educationService.changes$.switchMap(() => this.refresh()).subscribe(() => {});
    }

    init(step: Step) {
        super.init(step);
    }

    setCurrentScreen(screen: Screen, route: ActivatedRouteSnapshot) {
        super.setCurrentScreen(screen, route);
        this._currentScreen$.next(screen);
    }

    hasPreviousScreen(): boolean {
        return false;
    }

    hasNextScreen(): boolean {
        return this.completedInUSA !== undefined && this._currentScreen!.id === PremedicalEducationScreens.QUESTION;
    }

    nextScreenId(): string|undefined {
        return this._nextScreenId();
    }

    private _nextScreenId(): string {
        return this.completedInUSA ? PremedicalEducationScreens.PREMEDICAL : PremedicalEducationScreens.ECFMG;
    }

    firstScreenId(): string|undefined {
        return this._theScreenId();
    }

    lastScreenId(): string|undefined {
        return this._theScreenId();
    }

    private _theScreenId(): string {
        switch (this.completedInUSA) {
            case undefined:
                return PremedicalEducationScreens.QUESTION;
            case true:
                return PremedicalEducationScreens.PREMEDICAL;
            case false:
                return PremedicalEducationScreens.ECFMG;
        }
    }

    protected _doRefresh(): Observable<any> {
        return this._educationService.getCurrentUserModel(CompletedInUSAProjection).do(value => this.medicalEducationCompletedInUsa = value);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/premedical/premedical-education-screens-manager.service.ts